
import { Component, Vue, Prop} from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import "@/store/modules/application";
const applicationState = namespace("Application");

import StepBase from "../StepBase.vue";
import TrialReadinessStatement from "./TrialReadinessStatement.vue";
import PeopleAtTrial from "./PeopleAtTrial.vue";
import IssuesForTrial from "./IssuesForTrial.vue";
import BackgroundTris from "./BackgroundTris.vue";
import DisclosureOfInformation from "./DisclosureOfInformation.vue";
import Witnesses from "./Witnesses.vue";
import RequirementsAndConsiderations from "./RequirementsAndConsiderations.vue";
import AboutTheTrial from "./AboutTheTrial.vue";
import OrdersAtTpc from "./OrdersAtTpc.vue";

import ReviewYourAnswersTris from "./reviewTRIS/ReviewYourAnswersTRIS.vue";
import PreviewFormsTris from "./reviewTRIS/PreviewFormsTRIS.vue";

import { stepInfoType } from "@/types/Application";
import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";

@Component({
    components:{
        StepBase,        
        TrialReadinessStatement,        
        PeopleAtTrial,
        IssuesForTrial,
        BackgroundTris,
        DisclosureOfInformation,
        Witnesses,
        RequirementsAndConsiderations,
        AboutTheTrial,
        OrdersAtTpc,
        ReviewYourAnswersTris,
        PreviewFormsTris        
    }
})
export default class TrialReadinessStatementStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

}
